import { render, staticRenderFns } from "./ResidentDirectory.vue?vue&type=template&id=6766927c&scoped=true"
import script from "./ResidentDirectory.vue?vue&type=script&lang=js"
export * from "./ResidentDirectory.vue?vue&type=script&lang=js"
import style0 from "./ResidentDirectory.vue?vue&type=style&index=0&id=6766927c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6766927c",
  null
  
)

export default component.exports